import { makeStyles, useTheme } from '@mui/styles';
import KenTextLabel from '../KenTextLabel';
import KenError from '../KenError';
import PhoneInput from 'react-phone-input-2';
import { Box, Divider, Typography, useMediaQuery } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import 'react-phone-input-2/lib/style.css';

const useStyles = makeStyles((theme) => ({
  inputFieldLabel: {
    fontFamily: '"GeneralSans" !important',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '100%',
    textTransform: 'capitalize',
    color: '#505F79',
    marginBottom: '6px !important',
  },
  phoneContainer: {
    display: 'flex',
    '& .phone-input': {
      fontFamily: '"GeneralSans" !important',
      fontStyle: 'normal',
      fontWeight: '400',
      width: '-webkit-fill-available !important',
      fontSize: '14px',
      lineHeight: '100%',
      color: '#000 !important',
      padding: '16px !important',
      order: 2,
      background: '#fff',
      border: '0.5px solid #B0B0B0',
      height: '55px !important',
      borderRadius: '8px',
      justifyContent: 'space-between',
      marginLeft: '11px !important',
      '&:hover': {
        border: '0.5px solid #B0B0B0',
      },
      '&:focus': {
        outline: '2px solid #000',
      },
      '&::placeholder': {
        fontSize: '16px',
        lineHeight: '100%',
        color: '#A8AFBC',
        fontFamily: '"GeneralSans" !important',
      },
    },
    [theme.breakpoints.down('md')]: {
      '& .phone-input': {
        height: '40px !important',
      },
    },
    '& .phone-dropdown': {
      position: 'relative !important',
      order: 1,
      borderRadius: '8px',
      border: '0.5px solid #B0B0B0',
      background: '#fff',
      '&.open': {
        background: '#fff',
        '& .selected-flag': {
          background: '#fff',
        },
      },
      '& .selected-flag': {
        width: '50px !important',
        padding: '10px !important',
        '&:hover': {
          background: '#fff',
        },
      },
    },
  },
  errorInput: {
    border: '1px solid #d32f2f !important',
    '&:focus': {
      outline: '2px solid #FC2C32 !important',
      '-webkit-box-shadow': 'none',
      'box-shadow': 'none',
    },
  },
}));

export default function KenPhoneInput(props) {
  const { error, success, ui, hideLabel = false, label } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Box component={'div'} className="d-flex flex-column" gap={'12px'}>
        {!hideLabel && !isMobileScreen && <KenTextLabel label={label ? label : 'Phone Number'} required={true} />}
        <Box display="flex" alignItems="flex-start">
          <PhoneInput
            {...props}
            containerClass={`${classes.phoneContainer}`}
            inputClass={`${classes.inputFieldLabel} phone-input ${error ? classes.errorInput : ''}`}
            buttonClass="phone-dropdown"
            country={'ae'}
            preferredCountries={['ae']}
            placeholder="Enter Number"
            onChange={(phone) => {
              if (typeof props.onChange === 'function') {
                if (phone.includes('+')) {
                  props.onChange(phone);
                } else {
                  props.onChange(`+${phone}`);
                }
              }
            }}
          />
        </Box>
      </Box>
      {props?.error && <KenError message={props?.error} single />}
      {success && (
        <Box display="flex" alignItems="flex-start" pt={1}>
          <Typography component="span">{success.icon || <DoneIcon fontSize="small" style={{ color: '#158467' }} />}</Typography>
          <Typography component="span" className={classes.successMessage} pl={1}>
            {success.message}
          </Typography>
        </Box>
      )}
      {ui && ui?.divider && (
        <Box mt={2} mb={2}>
          <Divider />
        </Box>
      )}
    </>
  );
}
